module.exports = __webpack_public_path__ + "static/img/10.48845d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/10.png
// module id = wUuX
// module chunks = 0